import { Dashboard } from "./Dashboard";

export function Imprimir() {
  return (
    <div>
      <div className="no-print" style={{ position: "sticky", top: 0, zIndex: 10, display: "flex", justifyContent: "center", padding: 12, background: "#EFE8DA" }}>
        <button className="btn btn-primary" onClick={() => window.print()}>
          Imprimir / salvar como PDF
        </button>
      </div>
      <Dashboard />
    </div>
  );
}
